var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStampPaidOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 8.245H10.12v14.56h3.723v-4.368h1.934c2.912 0 5.2-2.1 5.2-5.096 0-2.995-2.288-5.096-5.2-5.096zm0 6.656h-1.934v-3.1h1.934c.832 0 1.477.625 1.477 1.54s-.645 1.56-1.477 1.56zm15.927 7.904h4.014l-4.805-14.56h-4.534l-4.805 14.56h4.035l.624-2.1h4.847l.624 2.1zM27.189 17.5l1.456-4.95 1.477 4.95h-2.933zm11.34-9.256v14.56h3.724V8.245H38.53zm13.695 0h-5.927v14.56h5.927c4.015 0 7.072-3.162 7.072-7.28s-3.057-7.28-7.072-7.28zm0 10.961h-2.1v-7.363h2.1c1.997 0 3.432 1.456 3.432 3.682 0 2.225-1.435 3.681-3.432 3.681z",
    fill: "#00834E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.306,
    y: 3.306,
    width: 62.339,
    height: 26.12,
    rx: 0.752,
    stroke: "#00834E",
    strokeWidth: 1.002
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26 1.754h60.431v-3.508H4.261v3.508zM67.197 4.26v24.211h3.508V4.261h-3.508zm-2.506 26.717H4.261v3.509h60.43v-3.508zM1.754 28.471V4.261h-3.508v24.21h3.508zm2.506 2.506a2.506 2.506 0 01-2.506-2.506h-3.508a6.014 6.014 0 006.014 6.015v-3.508zm62.937-2.506a2.506 2.506 0 01-2.506 2.506v3.509a6.014 6.014 0 006.014-6.014h-3.508zM64.691 1.755a2.506 2.506 0 012.506 2.506h3.508a6.014 6.014 0 00-6.014-6.014v3.508zM4.261-1.754A6.014 6.014 0 00-1.755 4.26h3.508A2.506 2.506 0 014.26 1.754v-3.508z",
    fill: "#00834E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampPaidOutlined);
export default __webpack_public_path__ + "static/media/stamp-paid-outlined.2c9753aba7b50d4697269d830756e6a3.svg";
export { ForwardRef as ReactComponent };